var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('ViewerTool',{ref:"toolbar",on:{"onChangePlaying":_vm.onChangePlaying}}),_vm._v(" "),_c('GLRenderer',{ref:"renderer",attrs:{"is-playing":_vm.isPlaying}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }